import { render, staticRenderFns } from "./EstoqueUnidade.vue?vue&type=template&id=acef6068"
import script from "./EstoqueUnidade.vue?vue&type=script&lang=js"
export * from "./EstoqueUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports